module.exports = __webpack_public_path__ + "static/media/23.6b02ab1c.mp3";